import * as React from 'react';
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import OpenInNewIcon from '../../images/svg/open_in_new.svg';
import BVLogo from '../../images/svg/logo-bv.svg';
import BoatHistoryLogo from '../../images/boathistory-logosmall.png';
import ProgressiveLogo from '../../images/svg/progressive-logo.svg';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


const JDPACustomButton2 = ({anchorEl, open, handleMenuOpen, handleMenuClose}) => {
    const handleClick = (event) => {
        if (open) {
            handleMenuClose();
        } else {
            handleMenuOpen(event);
        }
    };

    React.useEffect(() => {
        const handleScroll = () => {
            if (open) {
                handleMenuClose();
            }
        };

        if (open) {
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [open]);

    return (
        <div className={open ? 'menu-button-container menu-button-container-selected' : 'menu-button-container'}>
            <button
                className={open ? 'menu-button menu-button-selected' : 'menu-button'}
                id="menu-button"
                aria-controls={open ? 'menu-button' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <span>Pricing & Values</span>
                {open ? (
                    <KeyboardArrowUpIcon className="menu-arrow-icon" />
                ) : (
                    <KeyboardArrowDownIcon className="menu-arrow-icon" />
                )}
            </button>
            <Menu
                classes={{'paper': 'menu-button-paper'}}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id="button-dropdown-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                disableScrollLock={true}
                sx={{
                    left: 424,
                    top:84
                }}
                BackdropProps={{
                    sx: {
                        top: 84
                    }
                }}
            >
                <div className={'jdpa-custom-menu-left'}>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a className={'menu-button-link'} href="https://www.jdpower.com/cars">Autos</a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a className={'menu-button-link'} href="https://www.jdpower.com/motorcycles">Motorcycles</a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a className={'menu-button-link'} href="https://www.jdpower.com/rvs">RVs</a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a className={'menu-button-link'} href="https://www.jdpower.com/boats">Boats</a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a className={'menu-button-link'} href="https://www.jdpower.com/manufactured-homes/">Manufactured Homes</a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a className={'menu-button-link'} href="https://www.jdpowervalues.com/">B2B Valuation Products</a>
                    </MenuItem>
                </div>
                <div className={'jdpa-custom-menu-right'}>
                    <span className={'menu-button-cat'}>Auto Resources</span>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a target="_blank" className={'menu-button-link'} href="https://www.beenverified.com/?utm_source=6388&utm_medium=affiliate&utm_campaign=1119&subid=&segfid=6388_1119&aff_sub=nav&aff_sub2=&aff_sub3=&ho_id=102f28c42cc1066830fc9315fb6378">
                            Vehicle History Report
                            <img src={OpenInNewIcon} className={'menu-button-icon'}/>
                            <img src={BVLogo} style={{ height: '15px', width: '98px' }}/>
                        </a>
                    </MenuItem>
                    <Divider className={'menu-divider'} />
                    <span className={'menu-button-cat'}>Specialty Resources</span>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a target="_blank" className={'menu-button-link'} href="https://boathistoryreport.com/?utm_source=jdp&utm_medium=Resources&hin=&boat=&price=&utm_campaign=affiliate&cbnadag=20211131453196874">
                            Boat History Report
                            <img src={OpenInNewIcon} className={'menu-button-icon'}/>
                            <img src={BoatHistoryLogo} style={{ height: '15px', width: '83px' }}/>
                        </a>
                    </MenuItem>
                    <div className={'menu-button-cat'}>
                        <span>Specialty Insurance</span>
                        <a target="_blank" href="https://www.progressive.com/lp/recreational/?code=9106000029">
                            <img src={ProgressiveLogo} style={{ height: '18px', width: '100px', margin: '0 10px' }}/>
                        </a>
                    </div>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a target="_blank" className={'menu-button-link'} href="https://www.progressive.com/lp/motorcycle/?code=9106010020&cbnadag=20211131454593880undefined">
                            Motorcycle Insurance
                            <img src={OpenInNewIcon} className={'menu-button-icon'}/>
                        </a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a target="_blank" className={'menu-button-link'} href="https://www.progressive.com/lp/rv/?code=9106000051&cbnadag=20227281755286978undefined">
                            RV Insurance
                            <img src={OpenInNewIcon} className={'menu-button-icon'}/>
                        </a>
                    </MenuItem>
                    <MenuItem className="menu-button-item" onClick={handleMenuClose} disableRipple>
                        <a target="_blank" className={'menu-button-link'} href="https://www.progressive.com/lp/boat/?code=9106000029&cbnadag=20211131455474290undefined">
                            Boat Insurance
                            <img src={OpenInNewIcon} className={'menu-button-icon'}/>
                        </a>
                    </MenuItem>
                </div>
            </Menu>
        </div>
    );
};

export default JDPACustomButton2;